import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Label,
  Input,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injections
import {
  InputPhone,
  PageWrapper,
  InputCpfCnpj,
  ZipCodeInput,
  SelectInputWithSearchApi,
} from '../../containers/componentsInjection';

export const OfficesFormPage = ({ validation, id, history, updatedAt }) => {
  return (
    <PageWrapper title={id ? 'Editar escritório' : 'Adicionar escritório'}>
      <Row>
        <Col>
          <Card>
            <div className="live-preview">
              <Form
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <CardBody>
                  <Row>
                    <Col md={8}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Nome
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="nameInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.nameInput || ''}
                        />
                        {validation.touched.nameInput &&
                        validation.errors.nameInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.nameInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <label
                          htmlFor="cleave-delimiters"
                          className="form-label"
                        >
                          CNPJ
                        </label>
                        <InputCpfCnpj
                          id="cnpjInput"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.cnpjInput || ''}
                          invalid={
                            !!(
                              validation.touched.cnpjInput &&
                              validation.errors.cnpjInput
                            )
                          }
                        />
                        {validation.touched.cnpjInput &&
                        validation.errors.cnpjInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.cnpjInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={12}>
                      <div className="mb-3">
                        <h5>Contato</h5>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="emailInput" className="form-label">
                          Email
                        </Label>
                        <Input
                          type="email"
                          className="form-control"
                          id="emailInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailInput || ''}
                        />
                        {validation.touched.emailInput &&
                        validation.errors.emailInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.emailInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <label htmlFor="phoneInput" className="form-label">
                          Celular
                        </label>
                        <InputPhone
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          id="phoneInput"
                          onBlur={validation.handleBlur}
                          value={validation.values.phoneInput || ''}
                        />
                        {validation.touched.phoneInput &&
                        validation.errors.phoneInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.phoneInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <label htmlFor="phone2Input" className="form-label">
                          Telefone
                        </label>
                        <InputPhone
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          id="phone2Input"
                          onBlur={validation.handleBlur}
                          value={validation.values.phone2Input || ''}
                        />
                        {validation.touched.phone2Input &&
                        validation.errors.phone2Input ? (
                          <p className="labelErrorValidation">
                            {validation.errors.phone2Input}
                          </p>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="mb-3">
                        <h5>Endereço</h5>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          CEP
                        </Label>
                        <ZipCodeInput
                          id="zipInput"
                          className="form-control"
                          changeInputs={(e) => {
                            validation.setValues({
                              ...validation.values,
                              zipInput: e.cep,
                              streetInput: e.logradouro,
                              neighborhoodInput: e.bairro,
                              address2Input: e.complemento,
                              cityInput: {
                                label: `${e.localidade} - ${e.uf} `,
                                value: e.ibge,
                              },
                            });
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.zipInput || ''}
                        />
                        {validation.touched.zipInput &&
                        validation.errors.zipInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.zipInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          Logradouro
                        </Label>
                        <Input
                          className="form-control"
                          id="streetInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.streetInput || ''}
                        />
                        {validation.touched.streetInput &&
                        validation.errors.streetInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.streetInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputState" className="form-label">
                          Número
                        </Label>
                        <Input
                          className="form-control"
                          id="numberInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.numberInput || ''}
                        />
                        {validation.touched.numberInput &&
                        validation.errors.numberInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.numberInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="address2Input" className="form-label">
                          Complemento
                        </Label>
                        <Input
                          className="form-control"
                          id="address2Input"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address2Input || ''}
                        />
                      </div>
                    </Col>
                    {validation.touched.address2Input &&
                    validation.errors.address2Input ? (
                      <p className="labelErrorValidation">
                        {validation.errors.address2Input}
                      </p>
                    ) : null}
                    <Col md={4}>
                      <div className="mb-3">
                        <Label
                          htmlFor="neighboorhoodInput"
                          className="form-label"
                        >
                          Bairro
                        </Label>
                        <Input
                          className="form-control"
                          id="neighboorhoodInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.neighboorhoodInput || ''}
                        />
                        {validation.touched.neighboorhoodInput &&
                        validation.errors.neighboorhoodInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.neighboorhoodInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="cityInput" className="form-label">
                          Cidade
                        </Label>
                        <SelectInputWithSearchApi validation={validation} />
                        {validation.touched.cityInput &&
                        validation.errors.cityInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.cityInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={12}>
                      <div>
                        <div className="form-check form-switch mb-3">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="isActive"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            checked={validation.values.isActive}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="isActive"
                          >
                            Ativo
                          </Label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>

                <CardFooter>
                  <Row>
                    <Col md={12}>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="card-text">
                          <small className="text-muted">{updatedAt}</small>
                        </span>
                        <div className="text-end">
                          <button
                            type="button"
                            className="btn btn-link me-3"
                            onClick={() => {
                              history.goBack();
                            }}
                          >
                            Cancelar
                          </button>
                          <button type="submit" className="btn btn-primary">
                            Salvar
                          </button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardFooter>
              </Form>
            </div>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
